import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics/adobe-analytics.service';
import { DashboardCallsService } from './services/dashboard-calls.service';
import { Subscription } from 'rxjs';
import { ModalBasicComponent } from './components/modal-basic/modal-basic.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { LoaderComponent } from './loader/loader.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [
        RouterOutlet,
        LoaderComponent,
        SnackbarComponent,
        ModalBasicComponent,
    ]
})
export class AppComponent implements OnInit, OnDestroy {
  private adobeAnalyticsService = inject(AdobeAnalyticsService);
  private accountservice = inject(DashboardCallsService);

  title = 'dashboard-new';

  private accountJsessionSubscribe: Subscription | undefined;
  private jsessionId = '';
  private biocatchFlag = false;

  constructor() {
    this.adobeAnalyticsService.initAdobeLaunchDataLayer();
    //this.adobeAnalyticsService.injectAdobeLaunchScript();
  }

  ngOnInit() {

    this.accountJsessionSubscribe = this.accountservice
      .getJsessionId()
      .subscribe((data) => {
        if (data.status === 200 && data.body) {
          try {
            const data2: any = JSON.parse(data.body);
            this.jsessionId = data2.jSessionId;
            this.biocatchFlag = data2.banBiocatch === 'true' ? true : false;
            localStorage.setItem('jsessionId', this.jsessionId);
            localStorage.setItem('biocatchFlag', this.biocatchFlag + '');
            console.log('jsessionId', this.jsessionId);

            console.log('biocatchFlag', this.biocatchFlag);

            if (this.biocatchFlag) {
              const self = this;
              /* let node = document.createElement('script');
                node.src = 'assets/js/biocatchScript.js';
                node.type = 'text/javascript';
                node.async = true;

                document.getElementsByTagName('head')[0].appendChild(node);
*/
              const nodeCallBiocatch = document.createElement('script');
              if (location.hostname.indexOf('bancanet.banamex.com') >= 0) {
                nodeCallBiocatch.src =
                  'https://bcdn-god.we-stats.com/scripts/26025d53/a4494242.js';
              } else {
                nodeCallBiocatch.src =
                  'https://bcdn-god.we-stats.com/scripts/4bc932c8/6a7c24a9.js';
              }
              nodeCallBiocatch.type = 'text/javascript';
              nodeCallBiocatch.async = true;
              nodeCallBiocatch.onload = function () {
                const node = document.createElement('script');
                // node.src = 'assets/js/biocatchScript.js';
                node.type = 'text/javascript';
                node.text =
                  'try {' +
                  "window.cdApi.changeContext('Dashboard');\n" +
                  "window.cdApi.setCustomerSessionId('" +
                  self.jsessionId +
                  "');\n" +
                  '}catch (e) {\n' +
                  "console.log('Error biocatch dashboard', e);\n" +
                  '}\n';
                node.async = true;
                document.getElementsByTagName('head')[0].appendChild(node);
              };

              document
                .getElementsByTagName('head')[0]
                .appendChild(nodeCallBiocatch);
            }
          } catch (e) {
            window.location.href = '/MXGCB/apps/logout/flow.action';
          }
        } else {
          window.location.href = '/MXGCB/apps/logout/flow.action';
        }
      });
  }

  getCookie(cname:string) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

  ngOnDestroy() {
    if (this.accountJsessionSubscribe) {
      this.accountJsessionSubscribe.unsubscribe();
    }
  }
}
